export const logEventToGraphite = ({label, percentage = 100}) => {
    const eventData = {
        label,
        percentage
    };

    if (typeof Fiverr !== 'undefined' && typeof Fiverr._logEventToGraphite === 'function') {
        Fiverr._logEventToGraphite(eventData);
    }
};

export default logEventToGraphite;



// WEBPACK FOOTER //
// ./src/utils/graphiteReporter.js